/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  paypalStatusRequest : ['status']
, paypalStatusSuccess : ['response']
, paypalStatusFailure : ['response']

, paypalLogoutRequest : ['status']
, paypalLogoutSuccess : ['response']
, paypalLogoutFailure : ['response']
})

export const PaypalTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  Expired : true
, Expires : 0
, Nonce : ''
, Prefix : 'paypal_access'
, name : ''
, email : ''
, fetching: null
, error: null
, success : null
})



// validate paypal billing agreement
export const paypalStatusRequest = (state, action) => {
  console.tron.display({
    name : 'paypalStatusRequest'
  , preview : 'action'
  , value : { state: state
            , action: action }
  })
  return state.merge( { fetching : true, success : false, error : null
                      , Expired : true, Expires : 0, Nonce : '', Prefix : 'paypal_access'
                    } )
}

// successful read user
export const paypalStatusSuccess = (state, action) => {
  console.log(action)
  let status = action.response.data.data
  console.tron.display( { name : 'paypalStatusSuccess'
                        , preview : 'Paypal status and nonce'
                        , value : { action : action }
                      } )

  return state.merge( { fetching : false, success : true, error : null
                      , Expired : status.Expired, Expires : status.Expires
                      , Nonce : status.nonce
                      , Prefix : status.Prefix
                    } )
}

// failed read user
export const paypalStatusFailure = (state, action) => {
  const { response } = action
  console.tron.display({
    name: 'paypalStatusFailure',
    preview: 'You should totally expand this',
    value: {
      state: state,
      action: action,
      response: response,
    }
  })
  return state.merge({ fetching: false, success : false, error : response })
}
export const paypalLogoutRequest = (state, action) => {
  return state.merge( { fetching : true, success : false, error : null
                      , Expired : true, Expires : 0, Nonce : '', Prefix : 'paypal_access'
                    } )
}
export const paypalLogoutSuccess = (state, action) => {
  let status = action.response.data.data
  return state.merge( { fetching : false, success : true, error : null
                      , Expired : true, Expires : 0, Nonce : '', Prefix : 'paypal_access'
                    } )
}
export const paypalLogoutFailure = (state, action) => {
  return state.merge( { fetching : false, success : false, error : action
                      , Expired : true, Expires : 0, Nonce : '', Prefix : 'paypal_access'
                    } )
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.PAYPAL_STATUS_REQUEST] : paypalStatusRequest
, [Types.PAYPAL_STATUS_SUCCESS] : paypalStatusSuccess
, [Types.PAYPAL_STATUS_FAILURE] : paypalStatusFailure

, [Types.PAYPAL_LOGOUT_REQUEST] : paypalLogoutRequest
, [Types.PAYPAL_LOGOUT_SUCCESS] : paypalLogoutSuccess
, [Types.PAYPAL_LOGOUT_FAILURE] : paypalLogoutFailure
})
